import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import UsersList from '../components/AdminComponents/UserList';
const AdminDashboard = () => {
 return (
    <>
{/* <InnerBanner pageKey="usersList" /> */}

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <UsersList/> 
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminDashboard;